import { useMemo } from 'react';
import { useLocation, Location } from 'react-router-dom';

interface LocationState {
	mainLocation?: Location;
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	[key: string]: any; // Adjust this to match the expected structure of your state
}

/** 
 use this hook if you want to read the mainLocation (main route and not contextual route - casino, sportsbook etc)
 from within a contextual route component. Its part of the location state but this hook will provide it directly
 */

const useMainLocationFromContext = () => {
	const location = useLocation();
	const mainLocation = useMemo(() => {
		const locationState = location.state as LocationState;
		if (locationState && locationState.mainLocation) {
			return locationState.mainLocation;
		}
		return null;
	}, [location.state]);

	return mainLocation;
};

export default useMainLocationFromContext;
